import React, { useState, createContext } from 'react';
import { getSessionStorage } from '@src/utils/helper.js';

const defaultState = {
    exitModalOpen: false,
    showExitModal: () => {},
    externalUrl: null,
    setExternalUrl: () => {},
    modalTrigger: null,
    setModalTrigger: () => {},
    remodulinModalOpen: false,
    showRemodulinModal: () => {},
};

const AppContext = createContext(defaultState);

const AppProvider = ({ children }) => {
    const [userData, setUser] = useState(null);
    const [isUserLoaded, setUserLoaded] = useState(false);
    const [remodulinModalOpen, showRemodulinModal] = useState(defaultState.remodulinModalOpen);
    const [exitModalOpen, showExitModal] = useState(defaultState.modalTrigger);
    const [externalUrl, setExternalUrl] = useState(defaultState.externalUrl);
    const [modalTrigger, setModalTrigger] = useState(defaultState.modalTrigger);

    if (userData === null) {
        setUser({
            ...(getSessionStorage('upi') ? { picture: getSessionStorage('upi') } : null),
            ...(getSessionStorage('cst')
                ? { remodulin_crm_optin: getSessionStorage('cst') === 'true' }
                : null),
            ...(getSessionStorage('udm')
                ? { remodulin_delivery_method: getSessionStorage('udm') }
                : null),
            ...(getSessionStorage('upt') ? { pump_type: getSessionStorage('upt') } : null),
            ...(getSessionStorage('usd')
                ? { remodulin_start_date: getSessionStorage('usd') }
                : null),
        });
    }

    const getUserDeliveryMethod = userData?.remodulin_delivery_method || 'iv';
    const getUserPumpType = userData?.pump_type || 'remunity';
    const getUserStartDate = userData?.remodulin_start_date || '0000-00-01';
    const getUserCrmConsent = userData?.remodulin_crm_optin || '';
    let isNewPatient = true;

    if (userData !== null && userData?.remodulin_start_date) {
        const currentDate = new Date();
        const userStartDate = new Date(userData?.remodulin_start_date);
        const monthDiff = currentDate.getMonth() - userStartDate.getMonth();
        const yearDiff = currentDate.getFullYear() - userStartDate.getFullYear();
        const duration = monthDiff + yearDiff * 12;
        isNewPatient = duration < 6;
    }

    const store = {
        isUserLoaded,
        setUserLoaded,
        exitModalOpen,
        showExitModal,
        externalUrl,
        setExternalUrl,
        modalTrigger,
        setModalTrigger,
        userData,
        setUser,
        getUserDeliveryMethod,
        getUserPumpType,
        getUserStartDate,
        getUserCrmConsent,
        isNewPatient,
        remodulinModalOpen,
        showRemodulinModal,
    };
    return <AppContext.Provider value={store}>{children}</AppContext.Provider>;
};

export default AppContext;

export { AppProvider };
